export default __webpack_public_path__ + "static/media/femimed_poczekalnia.6fba5476.webp";